export default __webpack_public_path__ + "static/media/NewAvatars.7c9fa8a0.png";